import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, WebsiteBlockAction } from '@sb/library/base';
import { WebsiteBlockEmbedDisplayItem, WebsiteBlockEmbedType } from '@sb/library/data-models';

@Component({
    selector: 'lib-map-design-block',
    templateUrl: './map-design-block.component.html',
    styleUrls: ['./map-design-block.component.scss']
})
export class MapDesignBlockComponent extends DesignBlockBaseViewComponent {
    @Input() websiteBlockData!: WebsiteBlockEmbedDisplayItem;

    EditClicked() {
        this.Scope.HandleBlockAction(this.websiteBlockData, WebsiteBlockAction.Edit);
    }

    get type(): WebsiteBlockEmbedType {
        return this.websiteBlockData.EmbedType;
    }

    get isFullWidth(): boolean {
        return this.websiteBlockData.IsFullWidth;
    }

    get url(): string | null {
        return this.websiteBlockData.Source;
    }

    get WebsiteBlockEmbedType(): typeof WebsiteBlockEmbedType {
        return WebsiteBlockEmbedType
    }
}
